import { ValidationStatus } from '../../../../../../../views/marketing/followers/import';

export default {
  status: {
    [ValidationStatus.Valid]: {
      title: 'Importul tău este aproape gata!',
      description: 'Apăsați butonul Continuare pentru a finaliza importul',
    },
    [ValidationStatus.HasInvalidContent]: {
      title: 'Unele date din fișier lipsesc sau au un format greșit',
      description:
        'Corectați erorile de mai jos și reîncărcați fișierul sau continuați pentru a ignora rândurile/celulele invalide',
    },
    [ValidationStatus.Invalid]: {
      title: 'Fișierul încărcat nu poate fi procesat',
      description: 'Corectați erorile de mai jos și încercați din nou',
    },
  },
  sections: {
    heading_validation: {
      title: 'Nepotrivire detectată în numele/ordinea coloanelor:',
      rules: {
        Exact: 'Coloana #{{column}} trebuie să fie prezentă și să se numească exact <strong>{{expected}}</strong>',
      },
    },
    content_validation: {
      title: 'Au fost detectate următoarele erori:',
      labels: {
        row: 'Rândul <strong>#{{row}}:</strong>',
        imported_rows_one: '{{count}} rând va fi importat',
        imported_rows_few: '{{count}} rânduri vor fi importate',
        imported_rows_other: '{{count}} rânduri vor fi importate',
        ignored_rows_one: '{{count}} rând va fi ignorat',
        ignored_rows_few: '{{count}} rânduri vor fi ignorate',
        ignored_rows_other: '{{count}} rânduri vor fi ignorate',
      },
      fields: {
        email: 'Email',
        phone_number: 'Număr de telefon',
        first_name: 'Prenume',
        last_name: 'Nume de familie',
        birthday: 'Data nașterii',
      },
      rules: {
        Required: 'Câmpul {{field}} este obligatoriu. Rândul va fi ignorat',
        Email: 'Câmpul {{field}} trebuie să fie o adresă de email validă. Rândul va fi ignorat',
        Phone: 'Câmpul {{field}} trebuie să fie un număr de telefon în format internațional. Câmpul va fi ignorat',
        Date: 'Câmpul {{field}} trebuie să fie o dată validă. Câmpul va fi ignorat',
      },
    },
  },
  buttons: {
    back_to_upload: 'Înapoi la încărcare',
    proceed: 'Continuă',
  },
  toasts: {
    error: 'Ceva nu a mers bine, vă rugăm contactați suportul',
  },
};
